import { call, put, takeEvery } from "redux-saga/effects"
import { DLogin } from "apis/DLogin"
import { callApi } from "sagas/Api"
import { GET_NOTICE_AGREEMENT, storeNoticeAgreement } from "actions"
import { getNoticeAgreement } from "apis/NoticeAgreement"
import { moveToTop } from "locale"

const AGREEMENT_NOT_EXISTS = "-"

export function* handleGetNoticeAgreement() {
  yield takeEvery(GET_NOTICE_AGREEMENT, execGetNoticeAgreement)
}

export function* execGetNoticeAgreement() {
  const { payload, error } = yield call(callApi, getNoticeAgreement)
  if (payload && !error) {
    for (const key in payload) {
      // null許諾対応のため
      if (payload[key] === AGREEMENT_NOT_EXISTS) {
        continue
      }
      // eslint-disable-next-line security/detect-object-injection
      payload[key] = !Boolean(payload[key] === "1")
    }
    yield put(storeNoticeAgreement(payload))
  } else {
    if (error.message === "invalid token") {
      // リフレッシュトークンが無効な場合
      yield call(DLogin, { prompt: false })
    } else if (error.message === "dauth error") {
      // サーバエラーなどでトークンリフレッシュに失敗した場合
      yield call(moveToTop)
    } else {
      // APIの処理に失敗した場合
      yield call(moveToTop)
    }
  }
}
